import { render, staticRenderFns } from "./BadgeStatus.vue?vue&type=template&id=01ea575a&"
import script from "./BadgeStatus.vue?vue&type=script&lang=js&"
export * from "./BadgeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports